import { number, object } from 'zod';

import {
  VoucherCountSchema,
  VoucheredOfferSchema,
  VoucherExpirationDaysSchema,
} from './award-vouchers.schema';

import { withIsEnabled } from '../utils/with-is-enabled';

const AwardVouchersConstraintEnabledSchema = object({
  voucheredOffer: VoucheredOfferSchema,
  voucherCount: VoucherCountSchema,
  voucherExpirationDays: VoucherExpirationDaysSchema,
});

const AwardVouchersConstraintDisabledSchema = object({
  voucheredOffer: VoucheredOfferSchema.partial(),
  voucherCount: VoucherCountSchema,
  voucherExpirationDays: number().optional(),
});

export const AwardVouchersConstraintSchema = withIsEnabled(
  AwardVouchersConstraintEnabledSchema,
  AwardVouchersConstraintDisabledSchema,
);
